import React, { useState } from "react";
import "../Styles/AddFamilyMemeberForClient.css";
import AddFamilyModal from "./AddFamilyModal";

export default function AddFamilyMemeberForClient({
  familyDetails,
  setFamilyDetails,
}) {
  const handleInputChange = (index, field, value) => {
    const updatedDetails = [...familyDetails];
    updatedDetails[index][field] = value;
    setFamilyDetails(updatedDetails);
  };

  const relationshipOptions = [
    { RelationshipId: 1, RelationshipName: "Father" },
    { RelationshipId: 2, RelationshipName: "Mother" },
    { RelationshipId: 3, RelationshipName: "Elder Brother" },
    { RelationshipId: 4, RelationshipName: "Elder Sister" },
    { RelationshipId: 5, RelationshipName: "Son" },
    { RelationshipId: 6, RelationshipName: "Daughter" },
    { RelationshipId: 7, RelationshipName: "Uncle" },
    { RelationshipId: 8, RelationshipName: "Aunt" },
    { RelationshipId: 9, RelationshipName: "Cousin" },
    { RelationshipId: 10, RelationshipName: "Grandfather" },
    { RelationshipId: 11, RelationshipName: "Grandmother" },
    { RelationshipId: 12, RelationshipName: "Younger Brother" },
    { RelationshipId: 13, RelationshipName: "Younger Sister" },
    { RelationshipId: 14, RelationshipName: "Brother-in-law" },
    { RelationshipId: 15, RelationshipName: "Sister-in-law" },
  ];

  const [modalVisible, setModalVisible] = useState(false);
  const [relationModalVisible, setRelationModalVisible] = useState(false);

  const [selectedRelationShip, setSelectedRelationShip] = useState(
    relationshipOptions[2]
  );
  const [familyMemberName, setFamilyMemberName] = useState("");
  const [roleDesc, setRoleDesc] = useState("");
  const [Occupation, setOccupation] = useState("");

  const handleAddFamily = () => {
    const newMember = {
      RelationshipId: selectedRelationShip.RelationshipId,
      FamilyMemberName: familyMemberName,
      Occupation: Occupation,
      RoleDesc: roleDesc,
    };

    setFamilyDetails([...familyDetails, newMember]);
    setModalVisible(false);

    // Reset
    setSelectedRelationShip(relationshipOptions[0]);
    setFamilyMemberName("");
    setRoleDesc("");
  };

  const getRelationshipName = (id) => {
    const relation = relationshipOptions.find(
      (item) => item.RelationshipId === id
    );
    return relation ? relation.RelationshipName : null;
  };

  return (
    <section className="background-section">
      <header className="background-section__header">
        <h2 className="background-section__title">Family Information</h2>
        <div className="background-section__divider" />
      </header>
      <div className="d-flex flex-column">
        {familyDetails.map((member, index) => (
          <div key={member.RelationshipId} className="mb-4">
            {/* This label MUST be on its own line */}
            <div className="mb-2">
              <label className="background-section__label d-block">
                Enter {getRelationshipName(member.RelationshipId)} Name
              </label>
            </div>

            <div className="mb-4">
              <input
                type="text"
                className="background-section__input w-100"
                value={member.FamilyMemberName}
                onChange={(e) =>
                  handleInputChange(index, "FamilyMemberName", e.target.value)
                }
                placeholder={`Enter ${getRelationshipName(
                  member.RelationshipId
                )} Name`}
              />
            </div>

            <div className="mb-4">
              <input
                type="text"
                className="background-section__input w-100"
                value={member.Occupation}
                onChange={(e) =>
                  handleInputChange(index, "Occupation", e.target.value)
                }
                placeholder="Occupation"
              />
            </div>

            <div>
              <input
                type="text"
                className="background-section__input w-100"
                value={member.RoleDesc}
                onChange={(e) =>
                  handleInputChange(index, "RoleDesc", e.target.value)
                }
                placeholder="Role Description"
              />
            </div>
          </div>
        ))}
      </div>

      <div className="add-family-members" onClick={() => setModalVisible(true)}>
        <div className="add-rel-text">Add Family Members+</div>
      </div>

      <AddFamilyModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        onAdd={handleAddFamily}
        familyMemberName={familyMemberName}
        setFamilyMemberName={setFamilyMemberName}
        roleDesc={roleDesc}
        setRoleDesc={setRoleDesc}
        Occupation={Occupation}
        setOccupation={setOccupation}
        selectedRelationShip={selectedRelationShip}
        setSelectedRelationShip={setSelectedRelationShip}
        relationshipOptions={relationshipOptions}
      />
    </section>
  );
}
